import React, { useEffect, useState, useContext} from 'react'
import { useMediaQuery } from 'react-responsive';
import { Accordion, Button, Icon, Popup } from 'semantic-ui-react';
import HPTSelect from '../../../../templates/components/HPTSelect';
import ChartNotesService from '../../../../../services/api/chart-notes.service';
import ProductService from '../../../../../services/api/product.service';
import { store } from '../../../../../context/StateProvider'
import moment from 'moment';
import PatientService from '../../../../../services/api/patient.service';
import DimLoader from '../../../../templates/components/DimLoader';
import toast from 'react-hot-toast';
import TranscriptsService from '../../../../../services/api/transcripts.service';
import TranscriptsPanel from './TranscriptsPanel';

import { 
    useGetLocationServiceTypes,
    useGetLocationProviderServices,
 } from "../../../../../services/cache/CacheService";
import ChartNotesHistoryTable from './ChartNotesHistoryTable';
import APIResponse from '../../../../templates/components/APIResponse';
import UploadAudioDialog from './UploadAudioDialog';

const ChartNotes = (props) => {
    // context state and dispatch 
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state

    const isMobile = useMediaQuery({ query: `(max-width: 576px)` });

    const [isLoader, setIsLoader] = useState(false);
    const [treatmentPlans, setTreatmentPlans] = useState([]) 
    const [chartNotes, setChartNotes] = useState([]) 
    const [chartNotesHistory, setChartNotesHistory] = useState() 
    const [transcripts, setTranscripts] = useState()

    const [servicesList, setServicesList] = useState([])
    //const [productsList, setProductsList] = useState([])
    const [providersList, setProvidersList] = useState([])
    
    const [patient, setPatient] = useState()
    const [appointment, setAppointment] = useState(props?.appointment || {})

    const [locationId, setLocationId] = useState(props?.appointment?.practiceLocationId || state.practiceLocationId); 
    
    const [expandTreatmentPlans, setExpandTreatmentPlans] = useState(false);
    const [expandChartNotes, setExpandChartNotes] = useState(false);
    const [expandChartNotesHistory, setExpandChartNotesHistory] = useState(false);
    const [apiResponse, setApiResponse] = useState()
    const [mainAppointmentNote, setMainAppointmentNote] = useState(null);
    const stateServiceTypeList = useGetLocationServiceTypes();
    const stateDoctorList = useGetLocationProviderServices();
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const [expandTranscripts, setExpandTranscripts] = useState(false);
    const [showAddTranscript, setShowAddTranscript] = useState(false);
    const [showUploadTranscript, setShowUploadTranscript] = useState(false);
    const [showViewTranscript, setShowViewTranscript] = useState(false);
    const [selectedTranscript, setSelectedTranscript] = useState();

//#region Pull Data
useEffect(() => {
    if (!patient) {
        getPatient();
    }
    if (!transcripts) {
        getTranscripts();
    }
}, [])

const onCloseTranscript = () => {
    setShowViewTranscript(false);
    setSelectedTranscript(null);
    getTranscripts();
}

useEffect(() => {
    if (servicesList?.length>0 
        //&& productsList?.length>0 
        && chartNotes?.length==0) {
        getChartNotes();
    }
}, [servicesList, 
    //productsList
])

useEffect(() => {
    async function useEffectAsync() {
    if (locationId && stateServiceTypeList) {
        if (locationId == state.practiceLocationId) {
            setServicesList(stateServiceTypeList);
            setProvidersList(stateDoctorList);
        }   
        else {
            const [availability, equipment, providerServices, rooms, locServiceTypes] = await this.pullAllLocationData(newLocationId);
            setServicesList(locServiceTypes)
            setProvidersList(providerServices);
        }         
        //productLookup();
    }
    }
    useEffectAsync();
}, [locationId, stateServiceTypeList]);       


const getTreatmentPlans = (allPatientChartNotes) => {
    // get all treatment plans for patient even if completed
    const reqObj = { 
        PatientIds: appointment?.patientId
    };
    ChartNotesService.getTreatmentPlans(reqObj)
        .then(res => {
            if (res) {

                res.data?.forEach((treatmentPlan, i) => {
					treatmentPlan.pending = false;
                    treatmentPlan?.treatmentPlanDetail?.forEach((treatmentPlanDetail, i) => {

						// if (!treatmentPlan?.treatmentPlanDetail.completedInApptId || treatmentPlan?.treatmentPlanDetail.completedInApptId == appointment.Id) {
						// 	// Treatment plan detail is either pending still or was completed in this appointment, 
						// 	//   Allow treatment plan to be displayed
						// 	treatmentPlan.pending = true;
						// }

                        treatmentPlanDetail.history = [];

                        let history = allPatientChartNotes.filter(chartNote => 
                            chartNote.treatmentPlanDetailId === treatmentPlanDetail.treatmentPlanDetailId && 
                            chartNote.appointmentId !== appointment.id
                        );
                        if (history) {
                            treatmentPlanDetail.history = [...history];
                        }

                        let completedChartNote = history.filter(chartNote => chartNote.completed)

                        if (completedChartNote?.length==0) {

                            treatmentPlan.pending = true;


                            treatmentPlanDetail.chartNote = getNewChartNote(treatmentPlanDetail.treatmentPlanDetailId);
                            treatmentPlanDetail.chartNote.save = false;
    
                            // Add chart note for this treatment plan detail and this appointment
                            let apptChartNote = allPatientChartNotes.find(chartNote => 
                                chartNote.treatmentPlanDetailId === treatmentPlanDetail.treatmentPlanDetailId && 
                                chartNote.appointmentId === appointment.id
                            );
                            if (apptChartNote) {
                                treatmentPlanDetail.chartNote = {...apptChartNote};
                            }
                        }


                    })
                });
                // TODO Remove any treatment plans that do not have at least one detail still pending or a detail that was completed in this appointment
                //   Also, if a treatment plan doesnt have any pending details, dont show the treatment plan
                setTreatmentPlans(res.data)
            }
            setIsLoader(false)
        })
        .catch((err) => {
            setIsLoader(false)
            console.log(err);
        }
    );
}    

const getChartNotes = () => {
    setIsLoader(true)
    setChartNotes([]);
    setMainAppointmentNote(null);
    setTreatmentPlans([]);

    const reqObj = { 
        PatientIds: appointment?.patientId
    };
    ChartNotesService.getChartNotes(reqObj)
        .then(res => {
            if (Array.isArray(res.data)) {
                let responsive = res.data.sort( function (a, b){
                    return new Date(a.appointmentDate) - new Date(b.appointmentDate);
                });
                // History is everything that is not for this appointment
                let newChartNoteHistory = responsive
                    .filter(chartNote => chartNote.appointmentId !== appointment.id);
                setChartNotesHistory(newChartNoteHistory)
                // Just chart notes for this appointment and not for any treatment plan
                let additionalChartNotes = responsive
                    .filter(chartNote => chartNote.appointmentId === appointment.id && !chartNote?.treatmentPlanDetailId && chartNote.isAdditionalService==1);
                setChartNotes(additionalChartNotes)
                    // Main appointment note is the one that is not additional service and not for a treatment plan
                let mainApptNote = responsive
                    .find(chartNote => chartNote.appointmentId === appointment.id && !chartNote?.treatmentPlanDetailId && chartNote.isAdditionalService==0);
                if (mainApptNote) {
                    setMainAppointmentNote(mainApptNote)
                }
                // Pass all chart notes for patient
                getTreatmentPlans(responsive);
            }
            else {
                setIsLoader(false)
            }
        })
        .catch((err) => {
            setIsLoader(false)
        }
    );
}

const getPatient = () => {
    if (appointment?.patientId) {
        PatientService.getPatientById(appointment.patientId)
            .then(res => {
                setPatient(res.data)
            })
    }
    else {
        setPatient()
    }
}

// const productLookup = () => {
//     const reqObj = { 
//         practiceLocationId: locationId,
//         includePracticeItems: 'yes',
//         isActive: true 
//     };
//     ProductService.productLookup(reqObj)
//         .then(results => {
//             if (results) {
//                 let items = [];
//                 let itemType = 1;
//                 if (Array.isArray(results)) {
//                     items = results.filter(result => { return result?.itemType == itemType && (result?.practiceLocationId=="" || result?.practiceLocationId == locationId) });
//                 }
//                 setProductsList(items);
//         }})
// }

// const getProductName = (id) => {
//     let product = productsList?.find(obj => obj.id === id)
//     if (product) return product.name
//     return ''
// }
const getServiceName = (id) => {

    let service = servicesList?.find(obj => obj.practiceServiceTypeId === id)
    if (service) return service.practiceServiceType
    return ''
}
const getProviderName = (id) => {
    let provider = providersList?.find(obj => obj.id === id)
    if (provider) return provider.firstName + ' ' + provider.lastName
    return ''
}
//#endregion

//#region Treatment Plan chart notes
const changeTreatmentPlanChartNote = (modifiedTreatmentPlanDetail,e,i) => {
    
    let newList = [...treatmentPlans]

    let newValue = e.target.value

    if (e.target.name == 'completedInApptId') {
        if (e.target.value == true) {
            newValue  = appointment?.id;
        } 
        else {
            newValue  = null;
        }
    }

    newList?.forEach((treatmentPlan, i) => {
        treatmentPlan?.treatmentPlanDetail?.forEach((treatmentPlanDetail, i) => {
            if (modifiedTreatmentPlanDetail.treatmentPlanDetailId == treatmentPlanDetail.treatmentPlanDetailId) {

                // This should only be for completedInApptId since this form really only updates chartnote
                if (Object.hasOwn(treatmentPlanDetail, e.target.name)) {
                    treatmentPlanDetail[e.target.name] = newValue
                    treatmentPlanDetail.save = true;
                }

                if (Object.hasOwn(treatmentPlanDetail.chartNote, e.target.name)) {
                    treatmentPlanDetail.chartNote[e.target.name] = newValue
                    treatmentPlanDetail.chartNote.save = true;
                }
            }
        })
    });
    setTreatmentPlans(newList)
}
//#endregion

//#region Other Services
const getNewChartNote = (forTreatmentPlanDetailId, isAdditional) => {
    return {
        doctorId: appointment?.doctorId && (appointment?.doctorId !== "999999999" || appointment?.doctorId !== "") ? appointment?.doctorId : null,
        chartNotesId: 0,
        practiceServiceTypeId: isAdditional ? 0 : appointment?.practiceServiceTypeId,
        // quantity: 0,
        // itemId: 0,
        // area: "",
        notes: "",
        appointmentDate: appointment?.fromDate,
        appointmentId: appointment?.id,
        patientId: appointment?.patientId,
        treatmentPlanDetailId: forTreatmentPlanDetailId,
        isDeleted: false,
        save: false,
        isAdditionalService: isAdditional ? 1 : 0
    }
}

const addChartNote = () => {
    let newList = [...chartNotes]
    newList.push(getNewChartNote(null, true))
    setChartNotes([...newList])
}
// Replace the existing changeChartNotes function with this:
const changeChartNotes = (e, i) => {
    let newList = [...chartNotes];
    
    // Handle delete/undo logic
    if (e.target.name === 'isDeleted') {
        // If note has no ID and we're trying to delete it, just remove from array
        if (!newList[i].chartNotesId) {
            newList.splice(i, 1);
        } else {
            // Otherwise toggle isDeleted flag
            newList[i].isDeleted = e.target.value;
            newList[i].save = true;
        }
    } else {
        // Handle normal field updates
        newList[i][e.target.name] = e.target.value;
        newList[i].save = true;
    }
    setChartNotes([...newList]);
}

//#endregion


//#Transcripts

const hiddenColumns = ["appointmentDate"]

const transcriptsColumns = [
    {
        id: "dateCreated",
        Header: "Date",
        accessor: (cell) => moment.parseZone(cell.dateCreated).local().format("ddd MM/DD/YYYY hh:mma"),
    },
    {
        id: "medicalScribeJobStatus",
        Header: "Status",
        accessor: (cell) => cell.medicalScribeJobStatus,
    },
    {
        id: "actions",
        Header: "Actions",
        textAlign: 'center',
        disableSortBy: true,
        accessor: (transcript) => {
            return (
                <div className='d-flex justify-content-center'>
                    {transcript?.medicalScribeJobStatus?.toUpperCase() === "COMPLETED" && (
                        <div className='btn-group'>
                            <button className='btn btn-primary' title="View Form" onClick={e => { e.preventDefault(); setSelectedTranscript(transcript); setShowViewTranscript(true); }}>
                                <i className='icon pencil' />
                            </button>
                            {/* <button className='btn btn-primary' title="View Form" onClick={e => { e.preventDefault(); setSelectedTranscript(transcript); setShowViewTranscript(true); }}>
                                <i className='icon trash' />
                            </button> */}
                        </div>
                    )}
                </div>
            )
        }
    },


];

const getTranscripts = () => {
    const reqObj = { 
        AppointmentId: appointment?.id
    };
    TranscriptsService.getTranscripts(reqObj, appointment?.patientId)
        .then(res => {
            if (res?.data) {

                const data = res?.data ?? [];

                // Sort by dateCreated DESC (newest first). Clone so we don't mutate.
                const sorted = data.slice().sort((a, b) => {
                const ta = a?.dateCreated ? Date.parse(a.dateCreated) : 0;
                const tb = b?.dateCreated ? Date.parse(b.dateCreated) : 0;
                return tb - ta; // descending
                });

                setTranscripts(sorted);

            }
        })
        .catch((err) => {
            console.log(err);
        }
    );
}    


//#endregion

//#region Save 
const SaveChartNotes = () => {
    let chartNotesToUpdate = []
    setIsLoader(true)
    // Add main appointment note if it exists and has changes
    if (mainAppointmentNote?.save) {
        chartNotesToUpdate.push({
            ...mainAppointmentNote,
            appointmentId: appointment.id,
            isAdditionalService: 0 
        });
    }
    treatmentPlans?.forEach((treatmentPlan, i) => {
        treatmentPlan?.treatmentPlanDetail?.forEach((treatmentPlanDetail, i) => {
            if (treatmentPlanDetail.chartNote?.save) {
                treatmentPlanDetail.chartNote.treatmentPlanDetailId = treatmentPlanDetail.treatmentPlanDetailId;
                chartNotesToUpdate.push(treatmentPlanDetail.chartNote);
            } 
        })
    });

    chartNotes?.forEach((chartNote, i) => {
        // dont save any chart notes that are deleted and do not have a chart note id - these were added and deleted
        if (!(chartNote.chartNotesId == 0 && chartNote.isDeleted == 1) && chartNote.save) {
            chartNotesToUpdate.push({
                ...chartNote,
                isAdditionalService: 1
            });
        }
    });

    if (chartNotesToUpdate.length>0)
    {
        chartNotesToUpdate?.forEach((chartNote, i) => {
            chartNote.appointmentDate = moment(chartNote.appointmentDate).format("YYYY-MM-DD");
            chartNote.quantity = (parseFloat(chartNote.quantity)||0);
            //chartNote.isAdditionalService = 1;
            delete chartNote.save;

            if (!chartNote.treatmentPlanDetailId) delete chartNote.treatmentPlanDetailId;
            if (!chartNote.practiceServiceTypeId) delete chartNote.practiceServiceTypeId
            if (!chartNote.itemId) delete chartNote.itemId
            if (!chartNote.doctorId) delete chartNote.doctorId
            if (!chartNote.chartNotesId) delete chartNote.chartNotesId
        });

        ChartNotesService.updateChartNotes(chartNotesToUpdate)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }
    else
    {
        setIsLoader(false)
        toast.error("No changes were made")
    }
    // TODO need to update TreatmentPlanDetails completedInApptId field
}
//#endregion
    return (
<>
        {isLoader &&
            <DimLoader loadMessage="Loading" />
        }
        <div className="col-12">
            <div className="card p-3 mb-3" style={{ minHeight: '58px' }}>
                <div className="row d-flex align-items-center">
                    <div className='col-md-4 col-12'>
                        <div className='d-flex row'>
                            <div className="col row d-flex justify-content-between align-items-center">
                                <div className="col d-flex align-items-center financial-header">
                                    <div className="col-auto">
                                        <i className="icon user big text-primary" />
                                    </div>
                                    <div className='row d-flex justify-content-start financial-card-name'>
                                        <div className='col-auto'>
                                            <h5>
                                                {patient?.firstName ? patient.firstName + ' ' + patient?.lastName : patient?.name}
                                            </h5>
                                        </div>
                                    </div>
                                    <div className='col-auto' style={{padding:"5px"}}>
                                        {patient?.patientTags && patient?.patientTags.map(tag => {
                                            return (
                                                <span className={`badge text-white me-1 bg-info`}>{tag.name}</span>
                                            )
                                        })}
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-12">
                        <div className='d-flex row justify-content-center align-items-center financial-header-info'>
                            <div style={{textAlign:'center'}}>
                                <h5>{moment(appointment?.fromDate).format("dddd, MMMM, D")}</h5>
                            </div>
                            <div style={{textAlign:'center'}}>
                                <h5>{moment(appointment?.fromDate).format("h:mm a")} - {moment(appointment?.toDate).format("h:mm a")}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 col-12">
                        <div className='d-flex row justify-content-end align-items-center financial-header-info'>
                            <div style={{textAlign:'right'}}>
                                <h5>{appointment?.practiceServiceType}</h5>
                            </div>
                            <div style={{textAlign:'right'}}>
                                <h5>{appointment?.drFirstName} {appointment?.drLastName}</h5>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div className='col-12 mt-3'>
            <Accordion fluid styled>
                <>
                    {
                        //#region Chart Notes
                    }
                    <Accordion.Title
                        active={expandChartNotes}
                        index={2}
                        onClick={e => { e.preventDefault(); if (expandChartNotes) { setExpandChartNotes(false) } else { setExpandChartNotes(true) } }}
                    > 
                        <Icon name='dropdown' />
                        Chart Notes

                        {expandChartNotes ? <Icon name="plus" title="Add Service" className='btn p-0 m-0 float-right' onClick={e => { e.stopPropagation(); addChartNote() }} /> : null }
                    </Accordion.Title>
                        <Accordion.Content active={expandChartNotes}>
                            <div className="chart-notes-section">
                                {/* Main Appointment Section */}
                                <div className="main-appointment mb-2">
                                    <h6 className="section-title">Main Appointment</h6>
                                    <div className="d-flex flex-wrap align-items-center p-2 bg-light rounded">
                                        <div className="d-flex flex-wrap align-items-center w-100">
                                            <div className="me-3" style={{ minWidth: '200px' }}>
                                                <div className="d-flex flex-column">
                                                    <div className="d-flex align-items-center">
                                                        <span className="service-name">
                                                            {mainAppointmentNote
                                                                ? (servicesList?.find(s => s.practiceServiceTypeId === mainAppointmentNote.practiceServiceTypeId)?.practiceServiceType || appointment?.practiceServiceType)
                                                                : appointment?.practiceServiceType
                                                            }
                                                            {mainAppointmentNote && mainAppointmentNote.practiceServiceTypeId !== appointment?.practiceServiceTypeId && (
                                                                <Popup
                                                                    trigger={<Icon name="exclamation circle" color="orange" title="Service mismatch" />}
                                                                    content={
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                            <span>The service does not match the appointment.</span>
                                                                            <Icon
                                                                                name="exchange"
                                                                                color="blue"
                                                                                link
                                                                                title="Match appointment service"
                                                                                onClick={() =>
                                                                                    setMainAppointmentNote({
                                                                                        ...mainAppointmentNote,
                                                                                        practiceServiceTypeId: appointment?.practiceServiceTypeId,
                                                                                        save: true,
                                                                                    })
                                                                                }
                                                                            />
                                                                        </div>
                                                                    }
                                                                    position="top center"
                                                                    hoverable
                                                                />
                                                            )}
                                                        </span>
                                                        <span className="ms-2 text-muted">
                                                            {mainAppointmentNote
                                                                ? (() => {
                                                                    const provider = providersList?.find(p => p.id === mainAppointmentNote.doctorId);
                                                                    return provider
                                                                        ? `(${provider.firstName}${provider.lastName ? ` ${provider.lastName})` : ")"}`
                                                                        : "(No Provider Selected)";
                                                                })()
                                                                : (appointment?.drFirstName && appointment?.drFirstName !== ""
                                                                    ? `(Dr. ${appointment?.drFirstName}${appointment?.drLastName ? ` ${appointment?.drLastName})` : ")"}`
                                                                    : "(No Provider Selected)")}
                                                            {mainAppointmentNote && mainAppointmentNote.doctorId !== appointment?.doctorId && (
                                                                <Popup
                                                                    trigger={<Icon name="user times" color="orange" className="ms-1" />}
                                                                    position="top center"
                                                                    hoverable
                                                                    content={
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                            <span>The provider does not match the appointment.</span>
                                                                            <Icon
                                                                                name="exchange"
                                                                                color="blue"
                                                                                link
                                                                                title="Match appointment provider"
                                                                                onClick={() =>
                                                                                    setMainAppointmentNote({
                                                                                        ...mainAppointmentNote,
                                                                                        doctorId: appointment?.doctorId,
                                                                                        save: true,
                                                                                    })
                                                                                }
                                                                            />
                                                                        </div>
                                                                    }
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-grow-1 align-items-center">
                                                {!mainAppointmentNote ? (
                                                    <button
                                                        className="btn btn-transparent"
                                                        onClick={() => setMainAppointmentNote(getNewChartNote(null, false))}
                                                    >
                                                        <Icon name="plus" title="Add Chart Note"/>
                                                    </button>
                                                ) : (
                                                    <div className="d-flex align-items-center w-100">
                                                        <input
                                                            type="text"
                                                            name="notes"
                                                            className="form-control rounded"
                                                            style={{ flex: 1, marginRight: '15px' }}
                                                            value={mainAppointmentNote.notes || ''}
                                                            onChange={e => {
                                                                setMainAppointmentNote({
                                                                    ...mainAppointmentNote,
                                                                    notes: e.target.value,
                                                                    save: true
                                                                });
                                                            }}
                                                            placeholder="Notes"
                                                        />
                                                        <button
                                                            className="btn btn-transparent"
                                                            type="button"
                                                            onClick={(e) => {
                                                                if (!mainAppointmentNote.chartNotesId) {
                                                                    setMainAppointmentNote(null);
                                                                } else {
                                                                    setMainAppointmentNote({
                                                                        ...mainAppointmentNote,
                                                                        isDeleted: !mainAppointmentNote.isDeleted,
                                                                        save: true
                                                                    });
                                                                }
                                                            }}
                                                        >
                                                            <Icon
                                                                name={mainAppointmentNote?.isDeleted ? 'undo' : 'trash'}
                                                                title={mainAppointmentNote?.isDeleted ? 'Undo' : 'Remove'}
                                                            />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {chartNotes && chartNotes.length > 0 && (
                                    <table className='table table-borderless my-0 invoice-product-table'>
                                        {!isMobile ? <colgroup>
                                            <col span="1" />
                                            <col span="1" />
                                            {/* <col span="1" style={{ width: '15px' }}/>
                                <col span="1" />
                                <col span="1" />
                                <col span="1" style={{ width: '15px' }}/>
                                <col span="1" style={{ width: '150px' }}/> */}
                                            <col span="1" />
                                            <col span="1" style={{ width: '15px' }} />
                                        </colgroup> : null}

                                        <thead>
                                            <tr>
                                                <th className='py-2'>Provider</th>
                                                <th className='py-2'>Additional Services</th>
                                                {/* <th className='py-2'>$</th>
                                    <th className='py-2'>Area</th>
                                    <th className='py-2'>Product</th>
                                    <th className='py-2'>$</th>
                                    <th className='py-2'>Quantity</th> */}
                                                <th className='py-2'>Notes</th>
                                                <th className='py-2'></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {chartNotes?.map((otherService, i) => {
                                                return (
                                                    <tr key={otherService.chartNotesId} className='product-line'>
                                                        <td>
                                                            {isMobile ? <label>Provider</label> : ''}
                                                            <HPTSelect
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                options={providersList}
                                                                isDisabled={!providersList}
                                                                name="doctorId"
                                                                isClearable={true} isSearchable
                                                                value={providersList?.find(obj => obj.id === (otherService.doctorId))}
                                                                onChange={e => {
                                                                    if (e?.id) {
                                                                        changeChartNotes({
                                                                            target:
                                                                                { value: e.id, name: 'doctorId' }
                                                                        }, i)
                                                                    }
                                                                    else {
                                                                        changeChartNotes({
                                                                            target: {
                                                                                value: '', name: 'doctorId'
                                                                            }
                                                                        }, i)
                                                                    }
                                                                }}
                                                                getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                                                                getOptionValue={(option) => option.doctorId}
                                                            />
                                                        </td>
                                                        <td className=''>
                                                            {isMobile ? <label>Service</label> : ''}
                                                            <HPTSelect
                                                                options={servicesList}
                                                                className="react-select-container"
                                                                classNamePrefix="react-select"
                                                                isDisabled={!servicesList}
                                                                name="practiceServiceTypeId"
                                                                isSearchable
                                                                value={servicesList?.find(obj => obj.practiceServiceTypeId === otherService.practiceServiceTypeId)}
                                                                onChange={e => {
                                                                    if (e?.practiceServiceTypeId) {
                                                                        changeChartNotes({
                                                                            target:
                                                                                { value: e.practiceServiceTypeId, name: 'practiceServiceTypeId' }
                                                                        }, i)
                                                                    }
                                                                    else {
                                                                        changeChartNotes({
                                                                            target: {
                                                                                value: '', name: 'practiceServiceTypeId'
                                                                            }
                                                                        }, i)
                                                                    }
                                                                }}
                                                                getOptionLabel={(option) => option.practiceServiceType}
                                                                getOptionValue={(option) => option.practiceServiceTypeId}
                                                            />

                                                        </td>

                                                        {/* <td className="button-cell">
                                            </td>

                                            <td>
                                                {isMobile ? <label>Area</label> : null}
                                                <input type="text" name="area" onChange={e => { e.preventDefault(); changeChartNotes(e, i) }} value={otherService?.area} />
                                            </td>
                                            <td>
                                                {isMobile ? <label>Product</label> : null}

                                                <HPTSelect
                                                    options={productsList}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    isDisabled={!productsList}
                                                    name="itemId"
                                                    isSearchable
                                                    value={productsList?.find(obj => obj.id === otherService.itemId)}
                                                    onChange={e => {
                                                        if (e?.id) {
                                                            changeChartNotes({
                                                                target:
                                                                    { value: e.id, name: 'itemId' }
                                                            }, i)
                                                        }
                                                        else {
                                                            changeChartNotes({
                                                                target: {
                                                                    value: '', name: 'itemId'
                                                                }
                                                            }, i)
                                                        }
                                                    }}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.id}
                                                />

                                            </td>

                                            <td className="button-cell">
                                            </td>

                                            <td>
                                                {isMobile ? <label>Quantity</label> : null}
                                                <input type="number" name="quantity" onChange={e => { e.preventDefault(); changeChartNotes(e, i) }} value={otherService.quantity} />
                                            </td> */}
                                                        <td>
                                                            {isMobile ? <label>Notes</label> : null}
                                                            <input type="text" name="notes" onChange={e => { e.preventDefault(); changeChartNotes(e, i) }} value={otherService?.notes} />
                                                        </td>
                                                        <td className="button-cell">
                                                            <button className='btn btn-transparent' onClick={e => {
                                                                e.preventDefault();
                                                                changeChartNotes({
                                                                    target: {
                                                                        value: (otherService?.isDeleted ? 0 : 1), name: 'isDeleted'
                                                                    }
                                                                }, i)
                                                            }}>
                                                                <i className={'icon ' + (otherService?.isDeleted ? 'undo' : 'trash')} title={otherService?.isDeleted ? 'Undo' : 'Remove'} />{isMobile ? ' Remove from Chart Notes' : ''}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                            {/* <tr>
                                    <td colSpan={8}>

                                        <HPTSelect
                                            options={productList}
                                            onChange={e => {
                                                addProduct(e)
                                            }}
                                            value={null}
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Add Product"
                                            getOptionLabel={(option) => option.name
                                            +(option.manufacturerName ? (' | '+option.manufacturerName): "") 
                                            +  (option.tags &&  Array.isArray(option.tags) && option.tags.length>0 ? (' | '+ option.tags?.map(({ name }) => name).join(', ')) : "") 
                                            + ' | $' + option.unitPrice}
                                            getOptionValue={(option) => option.id}
                                        />
                                    </td>
                                </tr> */}

                                        </tbody>
                                    </table>
                                )}
                            </div>
                    </Accordion.Content>
{
    //#endregion
}

{
    //#region Treatment Plan Steps
}
{(treatmentPlans && Array.isArray(treatmentPlans) && treatmentPlans.length>0)  && <>
                    <Accordion.Title
                        active={expandTreatmentPlans}
                        index={1}
                        onClick={e => { e.preventDefault(); if (expandTreatmentPlans) { setExpandTreatmentPlans(false) } else { setExpandTreatmentPlans(true) } }}
                    > 
                        <Icon name='dropdown' />
                        Treatment Plans
                    </Accordion.Title>
                    <Accordion.Content active={expandTreatmentPlans}>

                        <table className='table table-borderless my-0 invoice-product-table'>
                            {!isMobile ? <colgroup>
                                <col span="1" />
                                <col span="1" />
                                <col span="1" />
                                {/* <col span="1" />
                                <col span="1" />
                                <col span="1" /> */}
                                <col span="1" />
                                <col span="1" />
                            </colgroup> : null}

                            <thead>
                                <tr>
                                    <th className='py-2' style={{textAlign:"center"}} ></th>
                                    <th className='py-2'>Date</th>
                                    <th className='py-2'>Provider</th>
                                    <th className='py-2'>Service</th>
                                    {/* <th className='py-2'>Area</th>
                                    <th className='py-2'>Product</th>
                                    <th className='py-2'>Quantity</th> */}
                                    <th className='py-2'>Notes</th>
                                    <th className='py-2'>Completed</th>
                                </tr>
                            </thead>
                            <tbody>
                                {treatmentPlans?.map((treatmentPlan, i) => {
                                    return (
                                        <>
                                            {i>0 &&
                                            <tr className='product-line'>
                                                <td className='' colSpan={9}>
                                                    <hr></hr>
                                                </td>
                                            </tr>
                                            }


                                            <tr key={treatmentPlan.treatmentPlanId} className='product-line'>
                                                <td className='' colSpan={9}>
                                                    {isMobile ? <label>Treatment Plan</label> : null}
                                                    <h5 className='py-2'>{treatmentPlan.treatmentPlan}</h5>
                                                </td>
                                            </tr>

                                            {treatmentPlan?.treatmentPlanDetail?.map((treatmentPlanDetail, i) => {
                                                return (
                                                    <>
                                                    <tr key={treatmentPlanDetail.treatmentPlanDetailId} className='product-line'>
                                                        <td className="button-cell">
                                                            Plan:
                                                        </td>

                                                        <td className=''>
                                                            {isMobile ? <label> 'Date Planned' </label>  : ''}
                                                            { moment(treatmentPlanDetail.datePlanned).format("MM/DD/YYYY") }
                                                        </td>
                                                        <td>
                                                            {isMobile ? <label> 'Provider' </label>  : ''}
                                                            {getProviderName(treatmentPlanDetail.doctorId)}
                                                        </td>
                                                        <td className=''>
                                                            {isMobile ? <label> 'Service' </label>  : ''}
                                                            {getServiceName(treatmentPlanDetail.practiceServiceTypeId)}
                                                        </td>
                                                        {/* <td>
                                                            {isMobile ? <label>Area</label> : null}
                                                            {treatmentPlanDetail.area}
                                                        </td>
                                                        <td>
                                                            {isMobile ? <label>Product</label> : null}
                                                            {getProductName(treatmentPlanDetail.itemId)}
                                                        </td>
                                                        <td>
                                                            {isMobile ? <label>Quantity</label> : null}
                                                            {treatmentPlanDetail.quantity}
                                                        </td> */}
                                                        <td>
                                                            {isMobile ? <label>Notes</label> : null}
                                                            {treatmentPlanDetail.notes}
                                                        </td>
                                                        <td className="button-cell">
                                                            {/* <input type="checkbox" 
                                                                className='form-check-input' 
                                                                checked={treatmentPlanDetail.completedInApptId}
                                                                name="completedInApptId" 
                                                                onChange={e => { 
                                                                    changeTreatmentPlanChartNote(treatmentPlanDetail, e, i)
                                                                }} 
                                                            /> */}
                                                        </td>
                                                    </tr>

                                                    {treatmentPlanDetail?.history?.map( (chartnote, i) => 
                                                        { 
                                                            return (
                                                                <>
                                        <tr key={chartnote.chartNotesId} className='product-line'>
                                            <td>
                                                {i==0 && <span>Actual:</span>}
                                            </td>
                                            <td>
                                                { moment(chartnote.appointmentDate).format("MM/DD/YYYY") }
                                            </td>



                                    <td>
                                        {isMobile ? <label> 'Provider' </label>  : ''}
                                        {getProviderName(chartnote.doctorId)}
                                    </td>
                                    <td className=''>
                                        {isMobile ? <label> 'Service' </label>  : ''}
                                        {getServiceName(chartnote.practiceServiceTypeId)}
                                    </td>
                                    {/* <td>
                                        {isMobile ? <label>Area</label> : null}
                                        {chartnote.area}
                                    </td>
                                    <td>
                                        {isMobile ? <label>Product</label> : null}
                                        {getProductName(chartnote.itemId)}
                                    </td>
                                            <td>
                                                {isMobile ? <label>Quantity</label> : null}
                                                {chartnote.quantity}
                                            </td> */}
                                            <td>
                                                {isMobile ? <label>Notes</label> : null}
                                                {chartnote?.notes}
                                            </td>
                                            <td className="button-cell">
                                                {chartnote.completed ? 'Yes' : ''}
                                            </td>
                                        </tr>
                                                                
                                                                
                                                                </>
                                                            )
                                                        }
                                                    )}




{treatmentPlanDetail.chartNote &&

                                        <tr key={treatmentPlanDetail.chartNote.chartNotesId} className='product-line'>
                                            <td colSpan={2}>
                                                
                                            </td>
                                            <td>
                                                {isMobile ? <label> 'Provider' </label>  : ''}
                                                <HPTSelect
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    options={providersList}
                                                    isDisabled={!providersList}
                                                    name="doctorId"
                                                    isClearable={true}
                                                    isSearchable
                                                    value={providersList?.find(obj => obj.id === (treatmentPlanDetail.chartNote.doctorId))}
                                                    onChange={e => {
                                                        if (e?.id) {
                                                            changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                                target:
                                                                    { value: e.id, name: 'doctorId' }
                                                            }, i)
                                                        }
                                                        else {
                                                            changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                                target: {
                                                                    value: '', name: 'doctorId'
                                                                }
                                                            }, i)
                                                        }
                                                    }}
                                                    getOptionLabel={(option) => option.firstName + ' ' + option.lastName}
                                                    getOptionValue={(option) => option.doctorId}
                                                />
                                            </td>
                                            <td className=''>
                                            {isMobile ? <label> 'Service' </label>  : ''}
                                                <HPTSelect
                                                    options={servicesList}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    isDisabled={!servicesList}
                                                    name="practiceServiceTypeId"
                                                    isSearchable
                                                    value={servicesList?.find(obj => obj.practiceServiceTypeId === treatmentPlanDetail.chartNote.practiceServiceTypeId)}
                                                    onChange={e => {
                                                        if (e?.practiceServiceTypeId) {
                                                            changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                                target:
                                                                    { value: e.practiceServiceTypeId, name: 'practiceServiceTypeId' }
                                                            }, i)
                                                        }
                                                        else {
                                                            changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                                target: {
                                                                    value: '', name: 'practiceServiceTypeId'
                                                                }
                                                            }, i)
                                                        }
                                                    }}
                                                    getOptionLabel={(option) => option.practiceServiceType}
                                                    getOptionValue={(option) => option.practiceServiceTypeId}
                                                />

                                            </td>

                                            {/* <td>
                                                {isMobile ? <label>Area</label> : null}
                                                <input type="text" name="area" onChange={e => { e.preventDefault(); changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,e, i) }} value={treatmentPlanDetail.chartNote?.area} />
                                            </td>
                                            <td>
                                                {isMobile ? <label>Product</label> : null}

                                                <HPTSelect
                                                    options={productsList}
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    isDisabled={!productsList}
                                                    name="itemId"
                                                    isSearchable
                                                    value={productsList?.find(obj => obj.id === treatmentPlanDetail.chartNote.itemId)}
                                                    onChange={e => {
                                                        if (e?.id) {
                                                            changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                                target:
                                                                    { value: e.id, name: 'itemId' }
                                                            }, i)
                                                        }
                                                        else {
                                                            changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                                target: {
                                                                    value: '', name: 'itemId'
                                                                }
                                                            }, i)
                                                        }
                                                    }}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.id}
                                                />

                                            </td>

                                            <td>
                                                {isMobile ? <label>Quantity</label> : null}
                                                <input type="number" name="quantity" onChange={e => { e.preventDefault(); changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,e, i) }} value={treatmentPlanDetail.chartNote?.quantity} />
                                            </td> */}
                                            <td>
                                                {isMobile ? <label>Notes</label> : null}
                                                <input type="text" name="notes" onChange={e => { e.preventDefault(); changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,e, i) }} value={treatmentPlanDetail.chartNote?.notes} />
                                            </td>
                                            <td className="button-cell">
                                                <input type="checkbox" 
                                                    className='form-check-input' 
                                                    checked={treatmentPlanDetail.chartNote?.completed}
                                                    name="completed" 
                                                    onChange={e => { 
                                                        changeTreatmentPlanChartNote(treatmentPlanDetail.chartNote,{
                                                            target: {
                                                                value: e.target.checked, name: 'completed'
                                                            }
                                                        }, i)
                                                    }} 
                                                /> 

                                            </td>
                                        </tr>
}
                                            </>
                                        )})
                                    }
                                </>
                                )})}
                            </tbody>
                        </table>
                    </Accordion.Content>
</>
}
{
    //#endregion
}

{
    //#region Transcripts
}
                    <>
                        <TranscriptsPanel
                            patientId={appointment.patientId}
                            appointmentId={appointment.id}
                            open={expandTranscripts}
                            onToggle={() => setExpandTranscripts(!expandTranscripts)}
                        />
                    </>

{
    //#endregion
}

{
    //#region Chart Notes History
}
                    <Accordion.Title
                        active={expandChartNotesHistory}
                        index={4}
                        onClick={e => { e.preventDefault(); if (expandChartNotesHistory) { setExpandChartNotesHistory(false) } else { setExpandChartNotesHistory(true) } }}
                    > 
                        <Icon name='dropdown' />
                        Chart Notes History
                    </Accordion.Title>
                    <Accordion.Content active={expandChartNotesHistory}>
                    {chartNotesHistory && <ChartNotesHistoryTable initialData={chartNotesHistory} isLoader={isLoader}/>}
                    </Accordion.Content>

{
    //#endregion
}

                </>
            </Accordion>
        </div>


        <div className='col-12 d-flex justify-content-end mt-3 modal-button-bar three'>
            <div className='col-auto'>
                <button className='btn btn-primary me-2 ' onClick={e => {e.preventDefault(); SaveChartNotes(); }}>
                    Save
                </button>
                <button className='btn btn-secondary me-2' onClick={e => {e.preventDefault(); props.onClose(); }} >
                    Cancel
                </button>
            </div>
        </div>
        <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />

    </>
    )
}
export default ChartNotes